import { useState } from 'react';

export default function PortfolioSection() {
  const [activeFilter, setActiveFilter] = useState('All');

  const filters = ['All', 'Web', 'Mobile', 'Branding'];

  const projects = [
    {
      id: 1,
      title: 'Fintech Dashboard',
      category: ['Web', 'UI/UX'],
      description: '金融テクノロジー企業向けの管理ダッシュボード。複雑なデータを直感的に可視化し、意思決定を支援するインターフェースを設計しました。',
      tech: 'React / TypeScript / D3.js / Figma',
      image: 'https://readdy.ai/api/search-image?query=Modern%20fintech%20dashboard%20interface%20with%20dark%20theme%2C%20clean%20data%20visualization%20charts%20and%20graphs%2C%20minimalist%20financial%20analytics%20UI%2C%20professional%20banking%20application%20design%2C%20navy%20blue%20and%20gold%20accent%20colors%2C%20sophisticated%20typography%2C%20desktop%20web%20application%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-fintech-001&orientation=landscape',
      size: 'standard'
    },
    {
      id: 2,
      title: 'Organic Cosmetics Brand',
      category: ['Branding', 'Web'],
      description: 'オーガニックコスメブランドの立ち上げプロジェクト。ブランドアイデンティティからECサイトまで、トータルでデザインを担当しました。',
      tech: 'Illustrator / Photoshop / Shopify / After Effects',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20organic%20cosmetics%20brand%20identity%20design%2C%20minimalist%20natural%20beauty%20product%20packaging%20with%20beige%20and%20earth%20tones%2C%20sophisticated%20botanical%20illustrations%2C%20luxury%20skincare%20branding%20mockup%2C%20clean%20product%20photography%20on%20neutral%20background%2C%20premium%20aesthetic&width=600&height=450&seq=portfolio-cosmetics-002&orientation=landscape',
      size: 'standard'
    },
    {
      id: 3,
      title: 'Meditation Mobile App',
      category: ['Mobile', 'UI/UX'],
      description: '瞑想とマインドフルネスをサポートするモバイルアプリ。心地よい音楽と視覚効果で、ユーザーのリラックス体験を最大化しました。',
      tech: 'Figma / Principle / Swift UI / Lottie',
      image: 'https://readdy.ai/api/search-image?query=Serene%20meditation%20mobile%20app%20interface%20design%2C%20calming%20gradient%20backgrounds%20with%20soft%20purple%20and%20teal%20colors%2C%20peaceful%20mindfulness%20app%20UI%20screens%2C%20floating%20iPhone%20mockup%2C%20minimalist%20wellness%20application%20design%2C%20tranquil%20atmosphere%20on%20dark%20background&width=600&height=450&seq=portfolio-meditation-003&orientation=landscape',
      size: 'standard'
    },
    {
      id: 4,
      title: 'Real Estate Platform',
      category: ['Web', 'UI/UX'],
      description: '不動産検索プラットフォームのリニューアル。地図連動機能と詳細フィルターにより、理想の物件探しを効率化しました。',
      tech: 'Next.js / Mapbox / Tailwind CSS / Framer Motion',
      image: 'https://readdy.ai/api/search-image?query=Modern%20real%20estate%20platform%20web%20design%2C%20sophisticated%20property%20listing%20interface%20with%20map%20integration%2C%20luxury%20apartment%20search%20website%20UI%2C%20clean%20architecture%20photography%2C%20beige%20and%20charcoal%20color%20scheme%2C%20professional%20real%20estate%20portal%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-realestate-004&orientation=landscape',
      size: 'standard'
    },
    {
      id: 5,
      title: 'Fitness Tracking App',
      category: ['Mobile', 'UI/UX'],
      description: 'パーソナルトレーニングをサポートするフィットネスアプリ。運動記録から栄養管理まで、包括的な健康管理を実現しました。',
      tech: 'Sketch / InVision / React Native / Firebase',
      image: 'https://readdy.ai/api/search-image?query=Dynamic%20fitness%20tracking%20mobile%20app%20interface%2C%20energetic%20workout%20statistics%20dashboard%20with%20vibrant%20orange%20and%20teal%20accents%2C%20modern%20health%20monitoring%20app%20UI%2C%20athletic%20performance%20metrics%20display%2C%20sleek%20smartphone%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-fitness-005&orientation=landscape',
      size: 'standard'
    },
    {
      id: 6,
      title: 'Artisan Coffee Brand',
      category: ['Branding', 'Web'],
      description: 'スペシャルティコーヒーブランドのブランディング。職人の想いを伝えるストーリーテリングを重視したデザインを展開しました。',
      tech: 'Illustrator / Photoshop / WordPress / Cinema 4D',
      image: 'https://readdy.ai/api/search-image?query=Artisan%20coffee%20brand%20identity%20design%2C%20premium%20specialty%20coffee%20packaging%20with%20warm%20brown%20and%20cream%20colors%2C%20handcrafted%20coffee%20shop%20branding%20materials%2C%20elegant%20typography%20and%20coffee%20bean%20illustrations%2C%20sophisticated%20cafe%20brand%20mockup%20on%20neutral%20background&width=600&height=450&seq=portfolio-coffee-006&orientation=landscape',
      size: 'standard'
    },
    {
      id: 7,
      title: 'Educational Platform',
      category: ['Web', 'UI/UX'],
      description: 'オンライン学習プラットフォームのUI/UX設計。学習者のモチベーション維持と効果的な知識習得を支援する設計を実現しました。',
      tech: 'Figma / Vue.js / Nuxt.js / GSAP',
      image: 'https://readdy.ai/api/search-image?query=Modern%20educational%20platform%20interface%20design%2C%20engaging%20online%20learning%20dashboard%20with%20colorful%20course%20cards%2C%20student-friendly%20e-learning%20website%20UI%2C%20interactive%20lesson%20interface%20with%20teal%20and%20gold%20accents%2C%20clean%20education%20portal%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-education-007&orientation=landscape',
      size: 'standard'
    },
    {
      id: 8,
      title: 'Travel Booking App',
      category: ['Mobile', 'UI/UX'],
      description: '旅行予約アプリのデザインリニューアル。直感的な検索機能と魅力的なビジュアルで、旅行計画の楽しさを最大化しました。',
      tech: 'Adobe XD / Flutter / Google Maps API',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20travel%20booking%20mobile%20app%20interface%2C%20inspiring%20destination%20photos%20with%20tropical%20beach%20imagery%2C%20modern%20vacation%20planning%20app%20UI%20screens%2C%20wanderlust-inducing%20travel%20application%20design%20with%20turquoise%20and%20warm%20sunset%20colors%2C%20elegant%20smartphone%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-travel-008&orientation=landscape',
      size: 'standard'
    },
    {
      id: 9,
      title: 'SaaS Product Design',
      category: ['Web', 'UI/UX'],
      description: 'B2B向けSaaSプロダクトのデザインシステム構築。複雑な機能を整理し、誰でも使いこなせるインターフェースを実現しました。',
      tech: 'Figma / Storybook / React / Design Tokens',
      image: 'https://readdy.ai/api/search-image?query=Professional%20SaaS%20product%20interface%20design%2C%20modern%20B2B%20software%20dashboard%20with%20clean%20component%20library%2C%20enterprise%20application%20UI%20with%20navy%20and%20gold%20color%20scheme%2C%20sophisticated%20business%20tool%20design%20system%2C%20desktop%20web%20app%20mockup%20on%20dark%20background&width=600&height=450&seq=portfolio-saas-009&orientation=landscape',
      size: 'standard'
    }
  ];

  const filteredProjects = activeFilter === 'All' 
    ? projects 
    : projects.filter(project => project.category.includes(activeFilter));

  return (
    <section id="portfolio" className="relative py-24 lg:py-32 bg-[#1a1a1a]">
      <div className="absolute left-0 bottom-1/4 w-96 h-96 bg-[#7ed6b8]/5 rounded-full blur-[150px]"></div>

      <div className="relative z-10 px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 gap-6">
          <div>
            <h2 className="text-5xl lg:text-6xl font-thin text-[#f5f5f0] leading-tight">
              Selected<br />
              <span className="text-7xl lg:text-8xl font-bold">Works</span>
            </h2>
          </div>

          <div className="flex flex-wrap gap-3">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeFilter === filter
                    ? 'bg-[#c9a96e] text-[#1a1a1a]'
                    : 'border border-[#c9a96e]/30 text-[#c9a96e] hover:border-[#c9a96e] hover:bg-[#c9a96e]/10'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, index) => (
            <div
              key={project.id}
              className="group cursor-pointer"
              style={{
                animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
              }}
            >
              <div className="relative overflow-hidden rounded-2xl bg-[#252525] h-full flex flex-col">
                <div className="relative overflow-hidden h-56 flex-shrink-0">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                    <div className="px-8 py-4 border-2 border-[#c9a96e] text-[#c9a96e] rounded-full font-medium opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 transform translate-y-4 group-hover:translate-y-0 whitespace-nowrap">
                      View Project
                    </div>
                  </div>
                </div>

                <div className="p-6 space-y-3 flex flex-col flex-1">
                  <h3 className="text-xl lg:text-2xl font-semibold text-[#d4c5b9] group-hover:text-[#c9a96e] transition-colors duration-300">
                    {project.title}
                  </h3>

                  <div className="flex flex-wrap gap-2">
                    {project.category.map((cat, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-[#2a2a2a] text-[#c9a96e] text-xs rounded-full"
                      >
                        {cat}
                      </span>
                    ))}
                  </div>

                  <p className="text-sm text-[#f5f5f0]/70 leading-relaxed flex-1">
                    {project.description}
                  </p>

                  <div className="pt-2">
                    <p className="text-xs text-[#c9a96e]/70">
                      {project.tech}
                    </p>
                  </div>

                  <div className="pt-2">
                    <a
                      href="#contact"
                      className="inline-flex items-center gap-2 text-sm text-[#d4c5b9] hover:text-[#c9a96e] transition-colors duration-300 group-hover:gap-3"
                    >
                      <span>詳細</span>
                      <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}